import { nanoid } from 'nanoid';
import { SocketEvent, } from '@/ts/socket';
import { getTimestamp, isCustomSurveyEvent } from './utils';
export const parseHistory = (event, avatar, t, user) => {
    const { history, context } = event;
    const events = [];
    let status = "open" /* SessionStatus.Open */;
    let remaining_keep_alive;
    history.forEach(([eventType, data]) => {
        var _a, _b;
        if (eventType === SocketEvent.message_send) {
            const eventData = data;
            const event = {
                author_avatar: user === null || user === void 0 ? void 0 : user.avatar,
                author_id: user === null || user === void 0 ? void 0 : user.user_id,
                author_name: user === null || user === void 0 ? void 0 : user.display_name,
                created_at: eventData.timestamp,
                delivered_at: undefined,
                event_id: nanoid(),
                event_type: 'user_message',
                read_at: undefined,
                text: eventData.input.text,
                attachments: eventData.input.attachments,
            };
            events.push(event);
        }
        if (eventType === SocketEvent.message_received) {
            const eventData = data;
            const event = {
                event_id: nanoid(),
                event_type: 'agent_message',
                author_name: eventData.from.agent_name,
                author_avatar: eventData.from.agent_avatar,
                author_id: eventData.from.agent_id,
                body: eventData.body,
                text: eventData.text,
            };
            events.push(event);
        }
        if (eventType === SocketEvent.message_brain_received) {
            const eventData = data;
            const responses = eventData.output.responses;
            const rootEvent = {
                event_type: 'brain_message',
                author_name: t('common.ai_agent'),
                author_avatar: avatar,
                author_id: nanoid(),
                request_id: eventData.request_id,
                // FIXME: we should get this from the event data
                created_at: getTimestamp(),
                source: 'history',
                collection: (_b = (_a = eventData.output) === null || _a === void 0 ? void 0 : _a.debug) === null || _b === void 0 ? void 0 : _b.collection,
            };
            responses.forEach((response) => {
                const event = Object.assign(Object.assign({}, rootEvent), { event_id: nanoid(), response });
                // Ignore default surveys
                if (!(response.type === 'survey' && !isCustomSurveyEvent(response))) {
                    events.push(event);
                }
            });
        }
        if ([SocketEvent.member_join, SocketEvent.member_leave].includes(eventType)) {
            const eventData = data;
            const event = {
                event_id: nanoid(),
                event_type: SocketEvent.member_join === eventType
                    ? 'member_join'
                    : 'member_leave',
                author_name: eventData.author_name || t('common.ai_agent'),
                author_type: eventData.author_type,
                author_avatar: eventData.author_avatar,
                author_id: eventData.author_id,
            };
            events.push(event);
        }
        if (eventType === SocketEvent.message_read) {
            const eventData = data;
            events.forEach((event) => {
                if (event.event_type === 'user_message') {
                    event.read_at = eventData.timestamp;
                }
            });
        }
        if (eventType === SocketEvent.message_delivered) {
            const eventData = data;
            events.forEach((event) => {
                if (event.event_type === 'user_message') {
                    event.delivered_at = eventData.timestamp;
                }
            });
        }
        if (eventType === SocketEvent.conversation_closed) {
            const { timestamp, keep_alive } = data;
            status = "closed" /* SessionStatus.Resolved */;
            remaining_keep_alive =
                -1 * ((getTimestamp() - timestamp) / 1000 - keep_alive);
        }
        if (eventType === SocketEvent.conversation_reopened) {
            status = "open" /* SessionStatus.Open */;
            remaining_keep_alive = undefined;
        }
    });
    return {
        context,
        events,
        status,
        remaining_keep_alive,
    };
};
